/* eslint-disable max-len */
export const notLetterOrNumber = new RegExp(/[^A-Za-z0-9]/, 'g');

// not integer, not float, not negative
export const notNumber = new RegExp(/[^-?\d+.?\d*$]/, 'g');

export const gaRegExp = new RegExp(/^(G|UA|YT|MO)-[a-zA-Z0-9-]+$/i);

// @link https://regexr.com/2ri2c
export const emailRegExp = /\b[\w\.-]+@[\w\.-]+\.\w{2,}\b/; // eslint-disable-line no-useless-escape

// @link https://regexr.com/38pvb
export const telRegExp = /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$$/;

export const uuidv4RegExp = /[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}/i;

export const passwordRegExp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+/[\]";:><,.-]).{8,}$/;

// @link https://regexr.com/38l9b
export const rgbaRegExp =
	/rgba\x28([012]\d\d|\d\d{0,1})(\s*?,\s*?)([012]\d\d|\d\d{0,1})(\s*?,\s*?)([012]\d\d|\d\d{0,1})(\s*?,\s*?)(0?\.\d+|[01])\x29/g;

export const fullName = /^([a-zA-Z]+)+([']*.)+([ ][a-zA-Z])+.*/;

export const urlRegExp = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/;

// @link https://regexr.com/3evse
export const domainRegExp = /^(?=^.{1,253}$)(([a-z\d]([a-z\d-]{0,62}[a-z\d])*[.]){1,3}[a-z]{1,61})$/;
